// extracted by mini-css-extract-plugin
export default {"refinmentList":"refinmentList--ff10907","onlyCompact":"onlyCompact--2b9f947","onlyRegular":"onlyRegular--21a389f","logoKidsDisabled":"logoKidsDisabled--6cdaddb"};